import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../api/supabase'

// Z73.5: single global toggle gating the eCustoms Preview page's "Submit to Descartes UAT"
// button -- off by default, so staff can only Download the CSVs and upload them to Descartes
// UAT manually until Gary confirms that manual test works and flips this on. Enforced again
// server-side in submit-ecustoms/index.ts (defense in depth, not just a disabled button).
export function useEcustomsSettings() {
  const [uatVerified, setUatVerifiedState] = useState(false)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(async () => {
    const { data } = await supabase.from('ecustoms_settings').select('uat_verified').eq('id', 'default').maybeSingle()
    setUatVerifiedState(data?.uat_verified ?? false)
    setLoading(false)
  }, [])

  useEffect(() => { refresh() }, [refresh])

  const setUatVerified = useCallback(async (value: boolean) => {
    const { data: { user } } = await supabase.auth.getUser()
    await supabase
      .from('ecustoms_settings')
      .update({ uat_verified: value, updated_by: user?.id || null, updated_at: new Date().toISOString() })
      .eq('id', 'default')
    await refresh()
  }, [refresh])

  return { uatVerified, loading, setUatVerified }
}
